var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessAdviceAndTraining = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Workflow-Coaching-Target-Arrow--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Workflow Coaching Target Arrow Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.67 10.45A4.27 4.27 0 1 0 10 14.72a4.27 4.27 0 0 0 -4.33 -4.27Zm0 7a2.77 2.77 0 0 1 -2.77 -2.73 2.83 2.83 0 0 1 0.35 -1.36 7.41 7.41 0 0 0 4 1.19 6.91 6.91 0 0 0 1.19 -0.1 2.45 2.45 0 0 1 0 0.27 2.78 2.78 0 0 1 -2.77 2.77Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14 20.19A6.48 6.48 0 0 0 0 24h11.36a6.09 6.09 0 0 0 -7.22 -3.81Zm2 2.24a0.5 0.5 0 0 1 -1 0v-1.29a0.5 0.5 0 0 1 1 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.07 7.61 -1.42 -0.13a5.77 5.77 0 0 1 0.47 2.28 5.67 5.67 0 0 1 -8.58 4.87 0.28 0.28 0 0 1 0 0.09 5.72 5.72 0 0 1 -0.29 1.81 7.49 7.49 0 0 0 10.35 -9 1.67 1.67 0 0 1 -0.53 0.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78 9.74a5.68 5.68 0 0 1 7.75 -5.26l-0.14 -1.55a1.7 1.7 0 0 1 0 -0.39 7.34 7.34 0 0 0 -1.95 -0.26A7.49 7.49 0 0 0 7 9a5.78 5.78 0 0 1 1.78 0.74Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 10.14A2.09 2.09 0 1 1 14 7.73l1.49 -1.57a3.74 3.74 0 1 0 2.73 3.6A3.85 3.85 0 0 0 18 8.57Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.65 2.41 -1.54 -0.52 -0.52 -1.54a0.51 0.51 0 0 0 -0.84 -0.2l-2.29 2.29a1 1 0 0 0 -0.29 0.8l0.13 1.38 -4.39 4.63a0.75 0.75 0 0 0 0 1.06 0.75 0.75 0 0 0 1.06 0l4.37 -4.61 1.42 0.13a1 1 0 0 0 0.8 -0.29l2.29 -2.29a0.51 0.51 0 0 0 -0.2 -0.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessAdviceAndTraining);
export default ForwardRef;